/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
// import { LinkContext } from 'cms/links/link-selector/context'

const LinkSelectHeader = () => {
    
    // const { selectedLink } = LinkContext
    return (
        <Fragment>
            <div className='simplicity-link-selector-window-title'>
                Link Selector
            </div>
        </Fragment>
    );
};

export { LinkSelectHeader };
